import React from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import {
  collectionFilterSortByText,
  collectionFilterSortOrder,
  collectionFilterIsPrivate,
  collectionFilterIsPrivateText,
} from '../../../../common/docs/content';
import CustomRadio from '../../../../common/ui/CustomRadio';
import CustomSelect from '../../../home/collections/CustomSelect';
import { getInitialValues, getValidationSchema, orderByOption } from './query-util';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';

const EditFilterDetails = ({
  filter,
  collectionFields,
  collection,
  projectId,
  version,
  actions,
  toggleModal,
}) => {
  const handleEditFilter = async (values) => {
    const editObj = {
      name: values.name,
      isPrivate: values.isPrivate,
      sortBy: values.selectSortField.value,
      orderBy: values.selectOrderBy.value,
    };
    const finalObject = {
      filterUuid: filter.uuid,
      projectId,
      collectionUuid: collection.uuid,
      data: editObj,
      version,
    };
    await actions.updateFilterDetails(finalObject);
    toggleModal();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={getInitialValues(filter)}
      validationSchema={getValidationSchema()}
      onSubmit={(values, { setSubmitting }) => {
        handleEditFilter(values);
        setSubmitting(false);
      }}
    >
      {({ values, isSubmitting, setFieldValue, setFieldTouched }) => (
        <Form className="form-horizontal">
          <div className="row mx-auto">
            <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label={'Filter Name'}
                  icon={'text'}
                  infoIcon={true}
                  infoDescription={''}
                >
                  <Field
                    type="text"
                    name="name"
                    className="form-control form-control-sm"
                    placeholder="Filter Name"
                  />
                  <ErrorMessage name="name">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label={'Sort By'}
                  icon={'select'}
                  infoIcon={true}
                  infoDescription={''}
                >
                  <CustomSelect
                    name="selectSortField"
                    isMulti={false}
                    value={values.selectSortField}
                    options={collectionFields}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    placeholder="Sort By"
                  />
                  <ErrorMessage name="selectSortField">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <TooltipInfo
                    title={collectionFilterSortByText}
                    headerText={`Select Sort By`}
                    showHeader={true}
                    showArrow={true}
                    iconColor="rgba(0, 0, 0, 0.87)"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label={'Order'}
                  icon={'select'}
                  infoIcon={true}
                  infoDescription={''}
                >
                  <CustomSelect
                    name="selectOrderBy"
                    isMulti={false}
                    value={values.selectOrderBy}
                    options={orderByOption}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    placeholder="Order"
                  />
                  <ErrorMessage name="selectOrderBy">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <TooltipInfo
                    title={collectionFilterSortOrder}
                    headerText={`Select Order By`}
                    showHeader={true}
                    showArrow={true}
                    iconColor="rgba(0, 0, 0, 0.87)"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <div className="form-group ml-2">
                <FormFieldWithLabel
                  cta={false}
                  label={'Private'}
                  icon={'toggle'}
                  infoIcon={true}
                  infoDescription={''}
                >
                  <div
                    className="form-check d-flex align-items-center  mt-2"
                    style={{ fontSize: 'unset' }}
                  >
                    <CustomRadio label="Is Private">
                      <Field type="checkbox" name="isPrivate" className="form-check-input" />
                    </CustomRadio>
                    <div className="ml-2">
                      <TooltipInfo
                        title={collectionFilterIsPrivate}
                        headerText={`Is Private`}
                        showHeader={true}
                        showArrow={true}
                        iconColor="rgba(0, 0, 0, 0.87)"
                      />
                    </div>
                  </div>
                  <div className="ml-3">
                    <small>{collectionFilterIsPrivateText}</small>
                  </div>
                  <ErrorMessage name="isPrivate">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12 mt-4 text-right">
              <button
                type="submit"
                className="btn btn-md btn-theme-submit"
                disabled={isSubmitting}
                title="Update Filter"
              >
                <i className={`wb webconnect-save-regular`}></i>&nbsp;Update
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default EditFilterDetails;
